
export default [
  {
    label: 'Legal Entity Event',
    jsonPath: '$.entity.associatedEntity.legalEntityEvents.legalEntityEvent',
    fieldId: 'LEIREC_ENTITY_EVENTS',
    type: 'STRING',
  },
]



// WEBPACK FOOTER //
// ./src/utils/challenge/entity-events.js